
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'
import { $orm } from '@/orm'

Vue.use(VueI18n)

// Create a new i18n instance with a default locale of english. Later on the
// application will set a locale and messages (strings) based on user
// preferences.
const i18n = new VueI18n({
  fallbackLocale: 'en',
  silentTranslationWarn: true
})

/**
 * When called sets the locale both in the current i18n instance and in the
 * locale store (which is persisted to local storage). This method will also
 * load the appropriate translations either from the store's localModule (if it
 * is present) or from the remote rest end-point (saving the result in the
 * localeModule)
 *
 * @param string locale e.g. en or en-US
 * @param boolean forceRefresh Defaults to false. When set to true then the
 * locale settings will be refreshed regardless of they're already loaded
 * @return null
 */
const setLocaleAsync = function (locale, forceRefresh = false) {
  if (store.getters['localeModule/locale'] !== locale) {
    store.dispatch('localeModule/setLocale', locale)
  }

  // Note that the translationsLoaded getter works off the locale we set above,
  // in other words we're asking "are the translations for the locale we just
  // set already loaded?". If not then fetch them from the rest end-point
  if (!store.getters['localeModule/translationsLoaded'] || forceRefresh) {
    $orm('Language')
      .find(locale, { requireAuth: false, requireCustomerContext: false })
      .then(language => {
        if (language.translations !== undefined) {
          store.dispatch('localeModule/setTranslationStrings', language.translations)
          i18n.locale = locale
          i18n.setLocaleMessage(locale, language.translations)
          document.querySelector('html').setAttribute('lang', locale)
        } else if (locale !== 'en') {
          // If the translations failed to load (perhaps a language/locale was
          // specified that is not supported) then fall back to english
          setLocaleAsync('en')
        }
      })
      .catch(error => {
        // Here of course we are unable to load a translated error
        // message so use an English string
        if (error) {
          store.dispatch('globalMessagingModule/showErrorModal', `Unable to load translations for the ${locale} locale`)
          throw (error)
        }
      })
  } else {
    i18n.locale = locale
    i18n.setLocaleMessage(locale, store.getters['localeModule/translationStrings'])
    document.querySelector('html').setAttribute('lang', locale)
  }
}

export {
  i18n,
  setLocaleAsync
}
